import { render, staticRenderFns } from "./OwalListSection.vue?vue&type=template&id=9f99318c&scoped=true"
import script from "./OwalListSection.vue?vue&type=script&lang=js"
export * from "./OwalListSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f99318c",
  null
  
)

export default component.exports